<script setup lang="ts">
import VehicleImageModal from './VehicleImageModal.vue';
import type Trip from '@itinerary/trip/Trip';
const { trip } = defineProps<{
    trip: Trip;
}>();
const { open } = useModal({
    component: VehicleImageModal,
    modalAttrs: {
        zIndexFn: () => 100000000,
    },
});

onMounted(() => trip.loadVehicleImages());
</script>

<template>
    <div class="images-container">
        <mr-dots-loading
            v-if="trip.vehicleImageLoadingStatus === 'Loading'"
            color="var(--blue-400)"
        />
        <div
            v-if="trip.vehicleImages.length"
            @click="
                () => {
                    open({
                        imageList: trip.vehicleImages.map(i => i.urls.original),
                        selectedImageIndex: 0,
                    });
                }
            "
        >
            تصاویر {{ trip.vehicleInfo.title }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.images-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    @include tg-m($w5, usePalette());
    cursor: pointer;
}
</style>
